import { IBetPosition } from '../../../../../../../../../../../types/reducers/betPosition';

export const getLeadBetPositionText = ({ page, offerPosition }: IBetPosition): string => {
  return `${page} страница, ${offerPosition} место`;
};
